import * as React from 'react';
import { Button, Modal } from '@watcherr/ui';
import { t } from '~/i18n';

import { DateRange, DayPicker } from 'react-day-picker';
import { useMutation } from '@tanstack/react-query';
import { endOfToday, subYears } from 'date-fns';

interface AlertResolveModalProps {
  onClose: () => void;
  maxDays: number;
  exportHandler: (start: Date, end: Date) => Promise<void>;
}

export const ExportModal: React.FC<AlertResolveModalProps> = ({ onClose, maxDays, exportHandler }) => {
  const [range, setRange] = React.useState<DateRange>();

  const exportMutation = useMutation({
    mutationFn: (range: DateRange) => exportHandler(range.from!, range.to!),
    onSuccess: () => onClose(),
  });

  const handleExport = () => {
    if (range) exportMutation.mutate(range);
  };

  const yearAgo = React.useMemo(() => subYears(new Date(), 1), []);
  const currentDay = React.useMemo(() => endOfToday(), []);

  return (
    <Modal onClose={onClose} style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-30">{t(`alerts.export.title`)}</h3>
      <p className="mb-30">{t(`alerts.export.description`).replace('31', maxDays.toString())}</p>

      <DayPicker
        ISOWeek
        mode="range"
        selected={range}
        onSelect={setRange}
        max={maxDays}
        hidden={{ before: yearAgo, after: currentDay }}
      />

      <Button
        className="mt-15 mb-15"
        loading={exportMutation.isPending}
        isBlock
        disabled={exportMutation.isPending || !range?.from || !range.to}
        onClick={handleExport}
      >
        {t(`alerts.export.submit`)}
      </Button>
    </Modal>
  );
};
